interface StatusBadgeProps {
  status: string;
}

const COLOR_MAP: Record<string, string> = {
  // greens — approved/completed/positive states
  APPROVED: 'bg-green-100 text-green-800',
  COMPLETED: 'bg-green-100 text-green-800',
  ACTIVE: 'bg-green-100 text-green-800',
  PROCESSED: 'bg-green-100 text-green-800',
  PAID: 'bg-green-100 text-green-800',
  DISBURSED: 'bg-green-100 text-green-800',
  SETTLED: 'bg-green-100 text-green-800',
  // yellows — pending/in-progress states
  PENDING: 'bg-yellow-100 text-yellow-800',
  SUBMITTED: 'bg-yellow-100 text-yellow-800',
  APPLIED: 'bg-yellow-100 text-yellow-800',
  REQUESTED: 'bg-yellow-100 text-yellow-800',
  DRAFT: 'bg-gray-100 text-gray-700',
  NEW: 'bg-yellow-100 text-yellow-800',
  UNDER_REVIEW: 'bg-yellow-100 text-yellow-800',
  // reds — rejected/cancelled/negative states
  REJECTED: 'bg-red-100 text-red-800',
  CANCELLED: 'bg-red-100 text-red-800',
  INACTIVE: 'bg-red-100 text-red-800',
  FORFEITED: 'bg-red-100 text-red-800',
  // blues — informational
  OFFER_EXTENDED: 'bg-blue-100 text-blue-800',
  OFFER_ACCEPTED: 'bg-blue-100 text-blue-800',
};

export default function StatusBadge({ status }: StatusBadgeProps) {
  const normalized = (status || '').toUpperCase();
  const classes = COLOR_MAP[normalized] || 'bg-gray-100 text-gray-700';

  return (
    <span className={`inline-block px-2 py-1 rounded-full text-xs font-semibold ${classes}`}>
      {status}
    </span>
  );
}
